export default __webpack_public_path__ + "static/media/pokeApiModels.06bb085a.zip";